<ng-template #warningModalForm let-modal>
  <div class="modal-body text-center">
    <lord-icon
      [colors]="colors"
      [src]="animationLink"
      style="width:120px;height:120px"
      trigger="loop"
    ></lord-icon>
    <div class="mt-4">
      <h4 class="mb-3"><span [innerHtml]="mainMessage"></span></h4>
      <p class="text-muted mb-4"><span [innerHtml]="subMessage"></span></p>
      <div class="hstack gap-2 justify-content-center">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm()">Close</button>
      </div>
    </div>
  </div>
</ng-template>
